<script>

import TimeLine from "@/components/2025/TimeLine/TimeLine.vue";
import SectionTitle from "@/components/2025/SectionTitle/SectionTitle.vue";
import TournamentGrid from "@/components/2025/Tournaments/TournamentGrid.vue";
import ChampionsList from "@/components/2025/Champions/ChampionsList.vue"

export default {
  name: "MainView",
  components: {ChampionsList, SectionTitle, TimeLine, TournamentGrid},
}
</script>
<template>
  <div>
    <div class="main-wrapper container">
      <div class="about-desc my-5">
        <SectionTitle title="About"/>
        <p class="m-0 p-0 text-white text-justify">
          The Ministry of Youth, Culture, and Communication is hosting the inaugural Morocco Gaming Expo 2025 in Rabat.
          From July 02nd to July 06th, 2025, this event will feature esports tournaments in four different games: EA FC 25, Valorant, FreeFire, and StreetFighter 6,
          with a total cash prize of 500.000 Moroccan Dirhams!
        </p>
      </div>
      <div class="timeline-container my-5">
        <TimeLine steps-key="home"/>
      </div>
      <div class="tagLine-container container text-center my-5">
        <h1 class="big-question">{{ $t("bigQuestion") }}</h1>
        <h4 class="get-ready">{{ $t("getReady") }}</h4>
      </div>
      <div class="tournaments-section mt-5 pt-5">
        <SectionTitle subtitle="Tournaments" title="Tournaments of This Edition" anchor="tournaments"/>
        <TournamentGrid/>
      </div>
    </div>
  </div>
</template>
<style scoped>
.about-desc {
  font-family: "sqwaredregular";
}
.big-question {
  color: white;
  font-family: "Sqwaredblack", sans-serif;
}
.get-ready {
  color: white;
  font-family: "sqwaredsemi_bold" !important;
}
.about-title{
  font-family: "sqwaredsemi_bold" !important;
  text-transform: uppercase;
}
</style>